
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';



const ProductComponent = (props) => {
  const [pin, setPin] = useState();
  const [checkpin, setCheckpin] = useState();
  const [size, setSize] = useState("");


  let { productId } = useParams();
  useEffect(() => {
    props.fetchProductById(productId)
  }, [productId])




  const tshirt = props.singleproduct;

  const onAddToCart = () => {
    props.add_to_cart(tshirt._id, tshirt.title, size, tshirt.price, 1);

  }




  const onPinchange = (e) => {
    setPin(e.target.value);


  };
  const handleInputChange = (e) => {

    setSize(e.target.value);

  }
  const checkService = () => {


    for (let i = 0; i < props.pins.length; i++) {
      if (props.pins[i].pincode == pin) {
        setCheckpin(true);
        break;
      }
      else {
        setCheckpin(false);
      }
    }

  };



  return (

    <>
      <section className="text-gray-600 body-font overflow-hidden">
        <div className="container px-5 py-5 mx-auto">
          <div className="lg:w-4/5 mx-auto flex flex-wrap">
            <img alt="ecommerce" className="lg:w-1/2 w-full lg:h-full lg:p-10 lg:pb-20  object-cover object-center rounded" src={tshirt?.img} />
            <div className="lg:w-1/2 w-full lg:pl-10 lg:py-20 mt-6 lg:mt-0">
              <h2 className="text-sm title-font text-gray-500 tracking-widest"></h2>
              <h1 className="text-gray-900 text-3xl title-font font-medium mb-1">{tshirt.title}</h1>

              <p className="leading-relaxed">Fam locavore kickstarter distillery. Mixtape chillwave tumeric sriracha taximy chia microdosing tilde DIY. XOXO fam indxgo juiceramps cornhole raw denim forage brooklyn. Everyday carry +1 seitan poutine tumeric. Gastropub blue bottle austin listicle pour-over, neutra jean shorts keytar banjo tattooed umami cardigan.</p>
              <div className="flex mt-6 items-center pb-5 border-b-2 border-gray-100 mb-5">

                <div className="flex ml-6 items-center">
                  <span className="mr-3">Size</span>
                  <div className="relative">
                    <select onChange={(e) => handleInputChange(e)} class="rounded border appearance-none border-gray-300 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-200 focus:border-indigo-500 text-base pl-3 pr-10">
                      <option>Select Size</option>
                      {tshirt?.size?.[0]?.Qty !== 0 && <option>SM</option>}
                      {tshirt?.size?.[1]?.Qty !== 0 && <option>M</option>}
                      {tshirt?.size?.[2]?.Qty !== 0 && <option>L</option>}
                      {tshirt?.size?.[3]?.Qty !== 0 && <option>XL</option>}
                    </select>


                  </div>
                </div>
              </div>
              <div className="flex">
                <span className="title-font font-medium text-2xl text-gray-900">₹{tshirt.price}</span>


                <button onClick={() => onAddToCart()} className="flex ml-6 text-white bg-teal-500 border-0 py-2 px-6 focus:outline-none hover:bg-teal-600 rounded">Add to Cart</button>
                <button className="rounded-full w-10 h-10 bg-gray-200 p-0 border-0 inline-flex items-center justify-center text-gray-500 ml-4">
                  <svg fill="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" className="w-5 h-5" viewBox="0 0 24 24">
                    <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"></path>
                  </svg>
                </button>
              </div>
              <div className='mt-6 flex'>
                <input type="text" onChange={onPinchange} placeholder='Enter pincode' className='mr-3 border-gray-700 px-1 py-1'></input>

                <button onClick={() => checkService()} className="flex  text-white bg-teal-500 border-0 py-1 px-2 focus:outline-none hover:bg-teal-600 rounded">Check</button>
              </div>
              {checkpin && checkpin != null && <div className='text-green-500 mt-2'>Yay! This pincode is serviceable</div>}
              {!checkpin && checkpin != null && <div className='text-red-500 mt-2'>Sorry! This pincode is not serviceable</div>}
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default ProductComponent;